export default __webpack_public_path__ + "static/media/sms.ecceb2e8.png";